import { c as _c } from "react/compiler-runtime";
import { PrV2GroupSectionLayout } from '../../diff/pr-v2-group-section-layout';
import { Skeleton } from '@/components/ui/skeleton';
function PrV2ChangesGuideSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="space-y-2 @min-[64rem]/pr-diff:flex @min-[64rem]/pr-diff:items-center @min-[64rem]/pr-diff:justify-between @min-[64rem]/pr-diff:gap-3 @min-[64rem]/pr-diff:space-y-0"><Skeleton className="h-6 w-56 max-w-full" /><Skeleton className="h-4 w-28" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div data-testid="pr-v2-group-guide-skeleton" className="space-y-4">{t0}<div className="space-y-2"><Skeleton className="h-4 w-full" /><Skeleton className="h-4 w-11/12" /><Skeleton className="h-4 w-4/5" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function PrV2ChangesDiffSkeletons(t0) {
  const $ = _c(4);
  const {
    fileSkeletonKeys
  } = t0;
  let t1;
  if ($[0] !== fileSkeletonKeys) {
    t1 = fileSkeletonKeys.map(_temp);
    $[0] = fileSkeletonKeys;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="min-w-0 space-y-4">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}

/**
 * Where each group's name, explanation and Viewed control show: in the group card at the top
 * of the chat column, or beside each group in the diff.
 */
function _temp(fileSkeletonKey) {
  return <div key={`pr-v2-${fileSkeletonKey}`} className="overflow-hidden rounded-md border border-zinc-800"><div className="border-b border-zinc-800 bg-zinc-950 px-4 py-2"><div className="flex items-center justify-between"><Skeleton className="h-4 w-72 max-w-[60%]" /><div className="flex items-center gap-1"><Skeleton className="h-7 w-7 rounded-md" /><Skeleton className="h-7 w-7 rounded-md" /></div></div></div><div className="px-4 py-3"><Skeleton className="h-28 w-full" /></div></div>;
}
export type PrV2GroupGuidePlacement = 'card' | 'inline';

/**
 * File-list skeleton used inside the changes pane while diff payloads are loading.
 */
export function PrV2ChangesGroupSkeleton(t0) {
  const $ = _c(11);
  const {
    fileCount,
    groupGuide
  } = t0;
  let t1;
  if ($[0] !== fileCount) {
    t1 = Array.from({
      length: fileCount
    }, _temp2);
    $[0] = fileCount;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fileSkeletonKeys = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PrV2ChangesGuideSkeleton />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const guide = t2;
  const t3 = groupGuide === "inline" ? guide : null;
  let t4;
  if ($[3] !== groupGuide) {
    t4 = groupGuide === "card" ? <div className="md:hidden">{guide}</div> : null;
    $[3] = groupGuide;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== fileSkeletonKeys) {
    t5 = <PrV2ChangesDiffSkeletons fileSkeletonKeys={fileSkeletonKeys} />;
    $[5] = fileSkeletonKeys;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t6 = <PrV2GroupSectionLayout className="space-y-3" guide={t3}>{t4}{t5}</PrV2GroupSectionLayout>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp2(_, position) {
  return `changes-file-${position + 1}`;
}